import { ReactNode } from 'react';

import { Icon } from './icon';
import { Button } from './shadcn/button';
import { PopoverContent } from './shadcn/popover';

export function FilterPopoverContent({
  children,
  clearAllFilters,
}: {
  children?: ReactNode;
  clearAllFilters: () => void;
}) {
  return (
    <PopoverContent side="left" className="mt-12 flex max-h-[calc(100vh-6rem)] min-w-md flex-col" sideOffset={8}>
      <div className="-mx-4 -mt-3 rounded-t-md border-b bg-gray-50 p-4 font-medium text-gray-700">Filters</div>

      <div className="-mx-4 flex-1 overflow-y-auto px-4">
        <div className="mt-4 flex flex-col gap-4">{children}</div>
      </div>

      <div className="mt-4 flex w-full justify-end border-t pt-4">
        <Button onClick={clearAllFilters}>
          <Icon className="lucide--funnel-x" />
          <span>Clear All Filters</span>
        </Button>
      </div>
    </PopoverContent>
  );
}
